module.exports = __webpack_public_path__ + "img/portalmanagement_watchlist.786b6439.png";